/* istanbul ignore file */
import React from 'react'
import PropTypes from 'prop-types'
import { withTheme } from 'styled-components'
import { Box } from '@elparking/components'

const Icon = ({ theme, color, height }) => <Box height={height}>
    <svg style={{width: 'auto', height: '100%'}} viewBox='0 0 21 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path fillRule='evenodd' clipRule='evenodd' d='M15.345.856a2.923 2.923 0 0 1 4.133 4.133l-1.44 1.444a.6.6 0 0 1-.21.212l-7.36 7.385a1.5 1.5 0 0 1-1.062.44H7.362a1.5 1.5 0 0 1-1.5-1.5v-2.043a1.5 1.5 0 0 1 .442-1.063l7.381-7.355a.601.601 0 0 1 .218-.217L15.344.856zm-1.128 2.817l-7.066 7.041a.3.3 0 0 0-.089.213v2.044a.3.3 0 0 0 .3.3h2.044a.3.3 0 0 0 .213-.088l7.041-7.067-2.443-2.443zm3.29 1.593l-2.44-2.44 1.125-1.12v-.001A1.723 1.723 0 0 1 18.63 4.14l-.001.001-1.12 1.125zm-16.35-.02a2.812 2.812 0 0 1 1.988-.823h1.106a.6.6 0 1 1 0 1.2H3.145a1.612 1.612 0 0 0-1.611 1.612v9.953A1.612 1.612 0 0 0 3.144 18.8h9.953a1.612 1.612 0 0 0 1.612-1.612v-1.106a.6.6 0 0 1 1.2 0v1.106A2.812 2.812 0 0 1 13.098 20H3.145a2.812 2.812 0 0 1-2.812-2.812V7.235c0-.746.297-1.461.824-1.988z'
          fill={theme.colors[color]}/>
    </svg>
</Box>

Icon.propTypes = {
    height: PropTypes.string,
    theme: PropTypes.object,
    color: PropTypes.string,
}

export default withTheme(Icon)
